import React from 'react';
import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import {
  FiTv,
  FiMail,
  FiPhone,
  FiInstagram,
  FiYoutube,
  FiArrowUp,
  FiHeadphones,
} from 'react-icons/fi';
import './Footer.css';

const Footer = () => {
  const location = useLocation();
  const isHome = location.pathname === '/';

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const getLinkHref = (href) => {
    if (href.startsWith('#')) {
      return isHome ? href : `/${href}`;
    }
    return href;
  };

  const footerLinks = {
    produto: [
      { name: 'Recursos', href: '#features' },
      { name: 'Downloads', href: '#downloads' },
      { name: 'Planos', href: '#pricing' },
      { name: 'Atualizações', href: '/updates' },
    ],
    empresa: [
      { name: 'Sobre Nós', href: '#' },

    ],
    suporte: [
      { name: 'Central de Ajuda', href: 'https://wa.me/message/UZEOSUXP7IXTD1' }
    ],
    legal: [
      { name: 'Termos de Uso', href: 'terms' }
    ],
  };

  const socialLinks = [
    { icon: <FiInstagram />, href: 'https://www.instagram.com/contasesuportegamehub/#', name: 'Instagram' },
    { icon: <FiYoutube />, href: 'https://www.youtube.com/@ContasesuporteGameHub', name: 'YouTube' }
  ];

  return (
    <footer id="contact" className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <motion.div
            className="footer-brand"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="footer-logo">
              <FiTv className="logo-icon" />
              <span>CSG TV</span>
            </div>
            <p className="footer-description">
              A melhor experiência em IPTV premium. Assista seus canais favoritos
              em qualquer dispositivo, a qualquer hora.
            </p>
            <div className="footer-social">
              {socialLinks.map((social, index) => (
                <motion.a
                  key={index}
                  href={social.href}
                  className="social-link"
                  aria-label={social.name}
                  whileHover={{ scale: 1.2, y: -3 }}
                  whileTap={{ scale: 0.9 }}
                >
                  {social.icon}
                </motion.a>
              ))}
            </div>
          </motion.div>

          <div className="footer-links">
            {Object.entries(footerLinks).map(([category, links], categoryIndex) => (
              <motion.div
                key={category}
                className="footer-column"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: categoryIndex * 0.1 }}
              >
                <h4 className="footer-column-title">{category.charAt(0).toUpperCase() + category.slice(1)}</h4>
                <ul className="footer-column-links">
                  {links.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      {link.href.startsWith('/') && !link.href.startsWith('/#') ? (
                        <Link to={link.href} className="footer-link">
                          {link.name}
                        </Link>
                      ) : (
                        <a href={getLinkHref(link.href)} className="footer-link">
                          {link.name}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        </div>

        <div className="footer-contact">
          <motion.div
            className="contact-item"
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <FiMail className="contact-icon" />
            <div>
              <div className="contact-label">Email</div>
              <a href="mailto:contasesuportgamehub@gmail.com" className="contact-value">
                contasesuportgamehub@gmail.com
              </a>
            </div>
          </motion.div>

          <motion.div
            className="contact-item"
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <FiPhone className="contact-icon" />
            <div>
              <div className="contact-label">Telefone</div>
              <a href="https://wa.me/message/UZEOSUXP7IXTD1" className="contact-value">
                +55 21 97900-6678
              </a>
            </div>
          </motion.div>

          <motion.div
            className="contact-item"
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <FiHeadphones className="contact-icon" />
            <div>
              <div className="contact-label">Discord</div>
              <a href="https://discord.gg/9udcrzeJAP" className="contact-value">
                discord.gg/csgbr24
              </a>
            </div>
          </motion.div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} CSG TV. Todos os direitos reservados.
          </p>
          <motion.button
            className="scroll-to-top"
            onClick={scrollToTop}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            aria-label="Voltar ao topo"
          >
            <FiArrowUp />
          </motion.button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

